import { graphql, useFragment } from 'react-relay';
import type { FlagCell$key } from '@atlassian/jira-relay/src/__generated__/FlagCell.graphql';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export type Props = {
	fieldRef: FlagCell$key;
};

export const FlagCell = ({ fieldRef }: Props) => {
	const data = useFragment<FlagCell$key>(
		graphql`
			fragment FlagCell on JiraFlagField {
				flag {
					isFlagged
				}
			}
		`,
		fieldRef,
	);
	const { formatMessage } = useIntl();

	return data.flag?.isFlagged && formatMessage(messages.flagged);
};
